import { indorsoftRuAPI } from "../indorsoftRuApi"

export const bitrixSessionApiSlice = indorsoftRuAPI.injectEndpoints({
    endpoints: builder => ({
        // Получение текущего Bitrix sessid
        getBitrixSessionId: builder.query<{ sessid: string }, void>({
            query: () => ({
                url: `api/get_sessid.php`,
                method: 'GET',
                credentials: 'include',
            })
        }),
    })
})

export const {
    useGetBitrixSessionIdQuery
} = bitrixSessionApiSlice


